<div class="property-selector-component">
  <app-radio-button-dropdown
    [items]="userPortfolios"
    [iconTooltip]="'Portfolio'"
    [containerWidthCss]="'dashboard-property-selector ' + selectorsWidthCss"
    [formControl]="portfolio"
    [label]="'Portfolio'"
    [labelInside]="true"
    [labelCss]="'nowrap pre-title text-color gray7'"
    [valueCss]="'ellipsis text-color gray3 dropdown-value'"
    [optionCss]="'fade-truncate w-100 text-color gray3 dropdown-value'"
    [allowSearch]="true"
    [multiSelect]="false"
    [allowClear]="false"
    [attrAppendTo]="'body'"
  ></app-radio-button-dropdown>
  <app-radio-button-dropdown
    [items]="userProperties"
    [hidden]="
      !(
        dashboardViewType === DashboardViewType.PROPERTY_VIEW ||
        dashboardViewType === DashboardViewType.PROPERTY_WITH_GROUPING_VIEW
      )
    "
    [iconTooltip]="'Property'"
    [label]="'Property'"
    [labelInside]="true"
    [labelCss]="'nowrap pre-title text-color gray7'"
    [valueCss]="'ellipsis text-color gray3 dropdown-value'"
    [optionCss]="'fade-truncate w-100 text-color gray3 dropdown-value'"
    [containerWidthCss]="'dashboard-property-selector ' + selectorsWidthCss"
    [formControl]="properties"
    [allowClear]="false"
    [multiSelect]="false"
    [allowSearch]="true"
    [autoSortList]="false"
    [attrAppendTo]="'body'"
  ></app-radio-button-dropdown>
  <app-radio-button-dropdown
    [items]="groupingByItems"
    [hidden]="dashboardViewType !== DashboardViewType.PROPERTY_WITH_GROUPING_VIEW"
    [iconTooltip]="'Grouping'"
    [label]="'Grouping'"
    [labelInside]="true"
    [labelCss]="'nowrap pre-title text-color gray7'"
    [valueCss]="'ellipsis text-color gray3 dropdown-value'"
    [optionCss]="'fade-truncate w-100 text-color gray3 dropdown-value'"
    [containerWidthCss]="'dashboard-grouping-selector'"
    [formControl]="grouping"
    [allowClear]="false"
    [multiSelect]="false"
    [allowSearch]="false"
    [autoSortList]="false"
    [attrAppendTo]="'body'"
  ></app-radio-button-dropdown>
</div>
